module.exports = __webpack_public_path__ + "img/icon_gas_on.afe56c2c.png";